<template>
  <div>
    <h2 class="section-title">My Orders</h2>
    <br>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Order No.</th>
              <th>Subtotal, £</th>
              <th>Discount, %</th>
              <th>Shipping, £</th>
              <th>Admin Fee, £</th>
              <th>Total, £</th>
              <th>Status</th>
              <th>Type</th>
              <th>Location</th>
              <th>Ordered at</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="order in orders">
              <td>#{{ order.order_number }}</td>
              <td>£ {{ parseFloat(order.sub_total).toFixed(2) }}</td>
              <td>{{ order.discount_type }} {{ order.discount }}</td>
              <td>£{{ parseFloat(order.shipping_price).toFixed(2) }}</td>
              <td>£{{ parseFloat(order.admin_fee).toFixed(2) }}</td>
              <td>£{{ parseFloat(order.total).toFixed(2) }}</td>
              <td>{{ order.status }}</td>
              <td class="text-capitalize">{{ order.type }}</td>
              <td class="text-capitalize">{{ getLocation(order.location_id).name }}</td>
              <td>{{ formatDate(order.created_at) }}</td>
              <td>
                <div class="btn btn-primary btn-xs" @click="view(order)">View Details</div>
                <div class="btn btn-danger btn-xs" @click="reorder(order)">Reorder</div>
              </td>
            </tr>
            <tr v-if="!orders">
              <td colspan="9" class="text-center">You have no orders</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div :class="['order-box', (showOrderBox !== null ? (showOrderBox ? 'animated fadeIn' : 'animated fadeOut') : 'not-displayed')]">
      <div class="order-content">
        <div class="close" @click="closePopup">×</div>
        <div v-if="!boxOrder" class="text-center pt-2 pb-2">
          <div class="loader-1"><span></span></div>
        </div>
        <div v-if="boxOrder" class="order-details">
          <h3>Order #{{ boxOrder.order_number }}</h3>
          <h5>Order placed at {{ formatDate(boxOrder.created_at) }}</h5>

          <div v-for="product in boxOrder.items">
            <div v-if="product.type == 'product'" class="order-box-product">
              <div class="product_title pull-left">
                {{ product.quantity }} x
                {{ product.title }}
              </div>
              <div class="product_price pull-right">
              <span v-if="product.discount > 0">
                <strike>£ {{ parseFloat(product.price).toFixed(2) }}</strike>
                £ {{ parseFloat(product.discount).toFixed(2) }}
              </span>
                <span v-else>£ {{ parseFloat(product.price).toFixed(2) }}</span>
              </div>
              <div class="clearfix"></div>
            </div>
            <div v-if="product.type == 'offer'" class="order-box-product">
              <div class="product_title pull-left">
                {{ product.quantity }} x
                {{ product.title }}
                <div class="offer-items">
                  <div v-for="(items, categoryTitle) in product.categorized_items">
                    <div class="offer-category">{{ categoryTitle }}</div>
                    <div class="offer-item" v-for="item in items">
                      {{ item.product_title }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="product_price pull-right">
              <span v-if="product.discount > 0">
                <strike>£ {{ parseFloat(product.price).toFixed(2) }}</strike>
                £ {{ parseFloat(product.discount).toFixed(2) }}
              </span>
                <span v-else>£ {{ parseFloat(product.price).toFixed(2) }}</span>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>

          <div class="box-order-details">
            <div class="order-detail">
              <div class="pull-left">Type</div>
              <div class="pull-right text-capitalize">{{ boxOrder.type }}</div>
              <div class="clearfix"></div>
            </div>
            <div class="order-detail">
              <div class="pull-left">Subtotal</div>
              <div class="pull-right">£{{ parseFloat(boxOrder.sub_total).toFixed(2) }}</div>
              <div class="clearfix"></div>
            </div>
            <div v-if="boxOrder.discount" class="order-detail">
              <div class="pull-left">Discount</div>
              <div class="pull-right">{{ boxOrder.discount }} {{ boxOrder.discount_type }}</div>
              <div class="clearfix"></div>
            </div>
            <div v-if="boxOrder.type == 'delivery'" class="order-detail">
              <div class="pull-left">Shipping</div>
              <div class="pull-right">£{{ parseFloat(boxOrder.shipping_price).toFixed(2) }}</div>
              <div class="clearfix"></div>
            </div>
            <div v-if="boxOrder.type == 'delivery' && boxOrder.delivery_address" class="order-detail">
              <div class="pull-left">Delivered to</div>
              <div class="pull-right text-right">{{ boxOrder.delivery_address }}</div>
              <div class="clearfix"></div>
            </div>
            <div v-if="boxOrder.type == 'delivery' && boxOrder.delivery_postcode" class="order-detail">
              <div class="pull-left">Postcode</div>
              <div class="pull-right">{{ boxOrder.delivery_postcode }}</div>
              <div class="clearfix"></div>
            </div>
            <div v-if="paymentSourceLabel(boxOrder)" class="order-detail">
              <div class="pull-left">Paid with</div>
              <div class="pull-right text-right">{{ paymentSourceLabel(boxOrder) }}</div>
              <div class="clearfix"></div>
            </div>
            <div class="order-detail">
              <div class="pull-left">Total</div>
              <div class="pull-right">£{{ parseFloat(boxOrder.total).toFixed(2) }}</div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <div class="btn btn-danger mb-3" @click="reorder(boxOrder)">Reorder</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'

  let kf

  export default {
    name: 'my-details',
    computed: {
      ...mapState({
        cart: state => state.cart,
        location: state => state.location
      }),
      ...mapGetters({
        getLocation: 'getLocation'
      })
    },
    data () {
      return {
        orders: null,
        boxOrder: null,
        showOrderBox: null
      }
    },
    created () {
      kf = this

      this.$store.dispatch('GetCustomerOrders')
        .then(response => {
          kf.orders = response.orders
        })
        .catch(error => {
          console.log(error)
        })
    },
    methods: {
      paymentSourceLabel (order) {
        let source = order ? order.payment_source : null

        if (!source) {
          return ''
        }

        let wallets = {
          apple_pay: 'Apple Pay',
          google_pay: 'Google Pay',
          link: 'Link'
        }

        let card = source.brand
          ? source.brand.charAt(0).toUpperCase() + source.brand.slice(1) + (source.last4 ? ' •••• ' + source.last4 : '')
          : ''
        let wallet = source.wallet ? (wallets[source.wallet] || source.wallet) : ''

        if (wallet && card) {
          return wallet + ' (' + card + ')'
        }

        return wallet || card || ''
      },
      formatDate (dateStr) {
        let date = new Date(dateStr)
        let curDate = new Date()

        let monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

        let day = date.getDate()
        let monthIndex = date.getMonth()
        let year = date.getFullYear()
        let hour = date.getHours()
        let minute = date.getMinutes()

        return this.formatToTwoDigits(day) + ' ' + monthNames[monthIndex] + ', ' + (year === curDate.getFullYear() ? (this.formatToTwoDigits(hour) + ':' + this.formatToTwoDigits(minute)) : year)
      },
      formatToTwoDigits (str) {
        return str.toString().length === 1 ? '0' + str : str
      },
      reorder (order) {
        if (order.location_id !== kf.location.id) {
          kf.notifyVue('danger', 'This order is not available for this location.')
          return false
        }

        order.items.forEach((product) => {
          let hasProductInCart = false

          if (product.type === 'product') {
            kf.cart.forEach((row) => {
              if (row.id === product.id) {
                row.quantity = row.quantity + product.quantity
                hasProductInCart = true
              }
            })

            if (!hasProductInCart) {
              kf.cart.push({
                type: 'product',
                id: product.id,
                title: product.title,
                code: product.code,
                image: product.image_path,
                price: product.price,
                discount: product.discount,
                quantity: product.quantity
              })
            }
          } else if (product.type === 'offer') {
            let itemsArr = []

            for (let categoryTitle in product.categorized_items) {
              itemsArr.push({
                category_id: product.categorized_items[categoryTitle][0].category_id,
                category_title: categoryTitle,
                products: product.categorized_items[categoryTitle].map(product => {
                  return {
                    id: product.product_id,
                    title: product.product_title,
                    code: product.product_code
                  }
                })
              })
            }

            this.cart.push({
              type: 'offer',
              offer_id: product.offer_id,
              title: product.title,
              code: product.code,
              image: null,
              price: product.price,
              discount: product.discount,
              note: product.note,
              quantity: product.quantity,
              items: itemsArr
            })
          }
        })

        kf.$store.dispatch('UpdateCart', this.cart)
        kf.notifyVue('success', 'This order has been added into your cart.')
        kf.$router.push({name: 'checkout'})
      },
      view (order) {
        this.showOrderBox = true

        setTimeout(function () {
          kf.boxOrder = order
        }, 1000)
      },
      closePopup () {
        this.showOrderBox = false

        setTimeout(function () {
          kf.showOrderBox = null
        }, 500)
      },
      notifyVue (type, message) {
        this.$notifications.notify({
          message: message,
          icon: '',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// my-orders.vue?1e3180c2